import {
    STORE_USER_SETTING,
} from "../../constants/account";

const initialState = {
    userTableSetting: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_USER_SETTING:
            return {
                ...state,
                userTableSetting: action.userTableSetting
            }
        default:
            return state
    }
};
